<template>
  <tr class="rf-skeleton-row h-32">
    <td class="pr-0! whitespace-nowrap" style="min-width: calc(24px + 1rem)"></td>
    <td class="5xl:px-7! px-5! text-right whitespace-nowrap">
      <RfBaseSkeleton class="5xl:hidden! inline-flex!" width="50" />
      <RfBaseSkeleton class="5xl:inline-flex! hidden!" width="100" />
    </td>
    <td class="pl-0!">
      <div class="flex flex-col gap-3">
        <RfBaseSkeleton width="200" dynamic />
        <RfBaseSkeleton width="132" dynamic />
      </div>
    </td>
    <!-- <td ><RfBaseSkeleton width="60" /></td> -->
    <td class="3xl:w-96 5xl:w-136 w-60 px-4 text-left whitespace-nowrap">
      <div class="flex flex-col gap-3">
        <template v-for="i in ~~(Math.random() * 3 + 1)" :key="i">
          <RfBaseSkeleton width="150" dynamic range="50" />
        </template>
      </div>
    </td>
    <td class="px-4! text-center whitespace-nowrap"><RfBaseSkeleton width="60" /></td>
    <td class="text-right"><RfBaseSkeleton width="60" /></td>
    <td class="bg-goal text-right"><RfBaseSkeleton width="60" /></td>
    <td class="px-2!"></td>
  </tr>
</template>

<script setup>
import RfBaseSkeleton from "@/components/skeletons/RfBaseSkeleton.vue";

defineProps({ performanceCols: { type: Boolean, default: false } });
</script>
